import { Truck } from "lucide-react";

const ITEMS = ["Köper", "Säljer", "Byter", "Husvagnar", "Husbilar", "Borås Fritid"];

export default function Marquee() {
  const row = (hidden) => (
    <div className="flex items-center shrink-0" aria-hidden={hidden ? "true" : undefined}>
      {ITEMS.map((item, i) => (
        <span
          key={`${item}-${i}`}
          className="flex items-center gap-8 md:gap-12 px-4 md:px-6 font-display font-bold tracking-[0.2em] uppercase text-lg md:text-2xl text-slate-500 whitespace-nowrap"
        >
          {item}
          <Truck className="text-brand shrink-0" size={22} />
        </span>
      ))}
    </div>
  );
  return (
    <div className="relative border-y border-metallic/60 bg-surface/40 py-5 overflow-hidden select-none" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
